import { render, staticRenderFns } from "./CytomineDescriptionModal.vue?vue&type=template&id=c1872c3e"
import script from "./CytomineDescriptionModal.vue?vue&type=script&lang=js"
export * from "./CytomineDescriptionModal.vue?vue&type=script&lang=js"
import style0 from "./CytomineDescriptionModal.vue?vue&type=style&index=0&id=c1872c3e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports